import React from 'react';
import T from 'i18n-react';

const Thead = () => (
    <thead>
        <tr >
            <td>
              <T.text tag='span' text="license_plate_fld"/>
            </td>
            <td>
              <T.text tag='span' text="parking_zone_fld"/>
            </td>
            <td className="td-amount">
              <T.text tag='span' text="amount_fld"/>
            </td>
        </tr>
    </thead>
);
export default Thead;



// WEBPACK FOOTER //
// ./src/components/history/Thead.js